import React, { useContext } from 'react';
import { StyleSheet } from 'react-native';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBTextBody2Bold } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';

export interface Props {
  isSelected: boolean;
  day: string;
  onSelect: () => void;
}

export function SelectableDay(props: Props) {
  const colors = useContext(ColorThemeContext);

  const styleSheets = StyleSheet.create({
    containerNotSelected: {
      borderRadius: 20,
      borderWidth: 2,
      height: 40,
      width: 40,
      maxWidth: 40,
      alignContent: 'center',
      justifyContent: 'center',
      borderColor: colors.button.background,
      backgroundColor: colors.button.backgroundInverted,
    },
    containerSelected: {
      borderRadius: 20,
      height: 40,
      width: 40,
      alignContent: 'center',
      justifyContent: 'center',
      borderColor: colors.button.backgroundInverted,
      backgroundColor: colors.button.background,
    },
  });

  return (
    <MBTouchableOpacity
      style={props.isSelected ? styleSheets.containerSelected : styleSheets.containerNotSelected}
      onPress={props.onSelect}
    >
      <MBTextBody2Bold
        align="center"
        color={props.isSelected ? colors.button.foreground : colors.button.foregroundInverted}
      >
        {props.day}
      </MBTextBody2Bold>
    </MBTouchableOpacity>
  );
}
